<div class="payment_explanation_modal_wrapper">
    <div class="payment_explanation_modal_body" v-click-outside="close">
        <div class="payment_explanation_modal_title">
            {{$t('order.explanation.header')}}
        </div>
        <div class="payment_explanation_modal_content">
            <p v-if="!isLoaded" class="payment_explanation_modal_loading">{{$t('datatable.load')}}</p>
            <paymentExplanation v-if="isLoaded && order?.explanation" :explanation="order.explanation" :currencySign="order.currencySign"></paymentExplanation>
        </div>
        <div class="payment_explanation_modal_buttons_wrapper">
            <button class="primary_button" @click="close">{{$t('order.explanation.close')}}</button>
        </div>
    </div>
</div>
